export default class priceCalc {

    calculate() {
        var simple = {
            'area_1' : 1800,
            'area_2' : 2300,
            'area_3' : 1800,
            'area_4' : 1800,
            'area_5' : 2300,
            'area_6' : 2300,
            'area_a' : 1550,
            'area_b' : 1550,
            'area_c' : 900,
            'area_d' : 900,
        }
    
        var multi = {
            'area_1' : 1500,
            'area_2' : 1000,
            'area_3' : 1000,
            'area_4' : 500,
            'area_5' : 1500,
            'area_6' : 1500,
            'area_a' : 1000,
            'area_b' : 1000,
            'area_c' : 500,
            'area_d' : 350,
        }
    
        var sizes = {
            's' : 0,
            'm' : 250,
            'l' : 500
        }

        var sizesA = {
            's' : 0,
            'm' : 500,
            'l' : 1250
        }

        var sizeId = $('#head_size').val();
        var countBeard = $('#calculate_area .area-beard.choose').length;
        var countHair = $('#calculate_area .area-hair.choose').length;
        var price = 0;
        var headAreaCount = 0;

        $('#calculate_area .area-beard.choose').each(function() {
            var id = $(this).data('area');

            if(countBeard>1) {
                price += multi[id];
            }
            else {
                price += simple[id];
            }
        });

        $('#calculate_area .area-hair.choose').each(function() {
            var id = $(this).data('area');
            headAreaCount++;

            if(countHair>1) {
                price += multi[id];
            }
            else {
                price += simple[id];
            }
        });

        if(countHair > 0 && sizeId) {
            if( headAreaCount == 6) {
                price += sizesA[sizeId];
            }
            else {
                price += sizes[sizeId];
            }
        }

        //add extra pay to multi choose
        if(countHair>1 || countBeard>1) {
            price += 500;
        }

        var person_val = $('#person').val();
        if(person_val) {
            price += parseInt(person_val);
        }

        $('#calculate_price').text(price + ' PLN');
    }


    init() {

        var cApp = this;
        var $calculator = $('#calculator');
        if($calculator.length) {
            
            $('.area').hover(function() {
                var data = $(this).data('area');
                $('[data-area="'+data+'"]').addClass('active');
    
            }, function() {
                $('.area').removeClass('active');
            }).click(function() {
                var data = $(this).data('area');
                $('[data-area="'+data+'"]').toggleClass('choose');
                cApp.calculate();
            });
    
            $('#head_size').change(function() {
                cApp.calculate();
            });

            $('#person').change(function() {
                cApp.calculate();
            });
        }
    }
}